export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 获取城市大使用户列表
    getCityMasterList: function getCityMasterList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/list",
        method: "get",
        params: data
      });
    },
    // 获取城市大使 时间周期
    getCityMasterRangeTime: function getCityMasterRangeTime() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/reset/upgrade/time/range",
        method: "get",
        params: data
      });
    },
    // 更新城市大使 时间周期
    updateCityMasterRangeTime: function updateCityMasterRangeTime() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/reset/upgrade/time/range",
        method: "post",
        data: data
      });
    },
    // 设置 | 取消 城市大使
    createCityMaster: function createCityMaster() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/create",
        method: "post",
        data: data
      });
    },
    updateCityMaster: function updateCityMaster() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/update",
        method: "post",
        data: data
      });
    },
    // 获取城市大使 邀请记录
    getCityMasterInviteRecord: function getCityMasterInviteRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/invite-record",
        method: "get",
        params: data
      });
    },
    // 设置邀请记录是否有效
    setCityMasterInviteRecord: function setCityMasterInviteRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/invite-record",
        method: "post",
        data: data
      });
    },
    // 结算记录
    getCityMasterSettlementList: function getCityMasterSettlementList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/bill",
        method: "get",
        params: data
      });
    },
    // 结算记录 | 结算单个cityMaster
    settlementCityMaster: function settlementCityMaster() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/invite-record/settlement",
        method: "post",
        data: data
      });
    },
    // 设置支付状态
    setPaymentStatus: function setPaymentStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/city-master/payment",
        method: "post",
        data: data
      });
    },
    // 设置支付状态
    setCityMasterAuth: function setCityMasterAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/city-master/auth/set",
        method: "post",
        data: data
      });
    }
  };
});